var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slick-carousel"},[_c('vueper-slides',{attrs:{"autoplay":_vm.autoplayCard,"pause-on-hover":true,"touchable":true,"fixed-height":_vm.fixedHeight,"slide-ratio":1 / 2,"arrows":_vm.arrows,"fade":"","fractions":""}},_vm._l((_vm.images),function(slide,i){return _c('vueper-slide',{key:i,attrs:{"image":slide}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }